import { useRef } from "react";
import { Camera, Upload, X } from "lucide-react";
import { toast } from "sonner";

const resize = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, 640 / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      resolve(c.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = reject;
    img.src = reader.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

export default function PhotoCapture({ value, onChange, color = "#C07C88" }) {
  const camRef = useRef(null);
  const fileRef = useRef(null);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.type.startsWith("image/")) return toast.error("Envie uma imagem");
    if (f.size > 15 * 1024 * 1024) return toast.error("Imagem grande demais (máx 15MB)");
    try { onChange(await resize(f)); } catch { toast.error("Não foi possível ler a imagem"); }
  };

  return (
    <div className="flex items-center gap-4" data-testid="photo-capture">
      <div className="relative w-24 h-24 rounded-full overflow-hidden border-2 flex items-center justify-center bg-white shrink-0" style={{ borderColor: color }}>
        {value ? <img src={value} alt="Foto" className="w-full h-full object-cover" data-testid="photo-preview" /> : <Camera size={28} style={{ color }} strokeWidth={1.4} />}
      </div>
      <div className="flex flex-col gap-2">
        <button type="button" onClick={() => camRef.current?.click()} className="inline-flex items-center gap-2 text-sm px-4 py-2 rounded-full text-white transition-opacity hover:opacity-90" style={{ background: color }} data-testid="photo-selfie-btn">
          <Camera size={14} /> Tirar selfie
        </button>
        <button type="button" onClick={() => fileRef.current?.click()} className="inline-flex items-center gap-2 text-sm px-4 py-2 rounded-full border border-border bg-white hover:bg-muted transition-colors" data-testid="photo-upload-btn">
          <Upload size={14} /> Enviar arquivo
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-red-500" data-testid="photo-remove-btn">
            <X size={12} /> Remover foto
          </button>
        )}
      </div>
      <input ref={camRef} type="file" accept="image/*" capture="user" className="hidden" onChange={pick} data-testid="photo-camera-input" />
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={pick} data-testid="photo-file-input" />
    </div>
  );
}
